
import { useEffect, useState } from "react";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import Input from "../../../../components/Inputs/Input";
import Item from "../../../../components/Lists/Item";
import './Kits.css';
import { LABELS } from "../../../../globals/globals";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { useDropdownConfig } from "../../../../contexts/DropdownsContext";
import { deleteKitItem, getKits, saveKitItem } from "../../services/KitsService";
import { localStorageSave } from "../../../../services/localStorageService";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { DialogTrigger } from "../../../../components/Dialog/Dialog";
import DeletePartDialog from "./DeletePartDialog";
import { Sorting } from "../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";



const createItm = () => ({
    id: -1 * Date.now(),
    "part_number": "",
    "description": "",
    "quantity": 1,
    "uom": ""
})

export const Kits = ({ part }) => {
    // const { config } = useDropdownConfig(29);
    const [parts, setParts] = useState([]);
    const [loading, setLoading] = useState([]);
    const [drafts, setDrafts] = useState({});
    const [orderBy, setOrderBy] = useState("");

    useEffect(() => {
        setLoading(true);
        getKits(part, orderBy).then(response => {
            if (response.data.responseCode === 200) {
                setParts(response.data.load);
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        })

    }, [part, orderBy]);

    const addItem = () => {
        // saveKitItem({ id: null, partId: part.id, quantity: 1, kitId: part.id }).then(response => {
        // });
        setParts(prev => [createItm(), ...prev]);
    }

    const discardItem = (kitItem) => {
        setParts(prev => prev.filter(i => !(i.id === kitItem.id)))
    }

    const itemUpdate = (item, prevItem) => {
        setParts(prev => {
            let foundIdx = prev.findIndex(i => i.id === prevItem.id);
            if (foundIdx !== -1) {
                let copy = [...prev];
                // FIXME: missing partNumber, partCategory, partSubCategory, partName in save-kit-part
                copy[foundIdx] = { ...prevItem, id: item.id, version: item.version };
                return copy;
            } else {
                return prev;
            }
        })
    }

    const orderChanged = (orderValue) => {
        setOrderBy(orderValue);
    }

    return (
        <div className='section kits-component'>
            <div className='section-header'>
                <h2>Kits</h2>
                <button onClick={addItem} className='filled iconTextButton small-size'>
                    <i style={{ fontSize: "0.6rem" }} className='icon-add-new'></i>
                    <span>Add PN</span>
                </button>
            </div>
            {
                <div className={`sorting-container ${parts.length < 1 ? 'hidden' : ''}`}>

                    <Sorting onOrderChange={orderChanged} showHeaderOrder properties={{ partNumber: "PN", description: "Description", categoryName: "Category", subCategoryName: "Sub Category", quantity: "Quantity" }} />
                </div>
            }



            {<>
                <div className="section-content">
                    {(loading === true) && <div>

                        <Skeleton height="var(--item-min-height)" />
                        <Skeleton height="var(--item-min-height)" />
                        <Skeleton height="var(--item-min-height)" />
                  
                    </div>}
                    {((loading === false) && parts.length === 0) && <div className="placeholder">
                        {/* The NLA hierarchy has not been configured for this part */}
                        <i>
                            No parts in this kit
                        </i>

                    </div>}
                    {((loading === false) && (parts.length > 0)) && parts.map(p => <KitItem updateItem={itemUpdate} discardItem={discardItem} sourcePart={part} kitItem={p} key={p.id} />)}
                </div></>}
        </div>

    )
}



const localStoragePrefix = "configuration/parts/engineering/kit";


const KitItem = ({ kitItem, sourcePart, discardItem, updateItem }) => {

    const [editing, setEditing] = useState(kitItem.id < 0);
    const [localKit, setLocalKit] = useState(kitItem);
    // const { config } = useDropdownConfig(75);
    const { config } = useDropdownConfig(75);
    const { successMsg, warningMsg, infoMsg } = useSnackBar();
    const [saveTry, setSaveTry] = useState(false);
    const [companyParameter, _] = useState([{ "columnName": "companyId", value: localStorage.getItem('u_company_id') }]);


    const handlePartChange = (newPart) => {
        if (newPart) {
            setLocalKit(prev => ({
                ...prev,
                kitId: sourcePart.id,
                partId: newPart["p.id"],
                partNumber: newPart.part_number,
                // partName: newPart.name,
                partDescription: newPart.description,
                categoryName: newPart.category_name,
                subCategoryName: newPart.sub_category_name,
                uomAbreviation: newPart.uom_abreviation

            }));
        }
        else {
            setLocalKit(prev => ({
                ...prev,
                kitId: sourcePart.id,
                partId: null,
                partNumber: "",
                partDescription: "",
                // partName: ""
                // categoryName: newPart.category_name,
                categoryName: "",
                subCategoryName: "",
                uomAbreviation: ""
                // subCategoryName: newPart.sub_category_name,

            }))
        }
    }

    const hanldeSave = (closeEdition) => {
        setSaveTry(true);
        if (typeof (localKit.partId) === 'number') {
            infoMsg("Saving part to kit", localKit.partNumber);
            saveKitItem(localKit).then(response => {
                if (response.data.responseCode === 204) {
                    successMsg("Kit updated");
                    let updatedItem = response.data.load;
                    // FIXME: missing partNumber, partCategory, partSubCategory, partName in save-kit-part
                    updateItem(response.data.load, localKit);
                    setLocalKit(prev => ({ ...prev, id: updatedItem.id, version: updatedItem.version }));
                    setSaveTry(false);
                }
            })
            if (closeEdition) {
                setEditing(false);
            }
        } else {
            warningMsg("Please Select a part number (PN)");
        }
    }

    const [kitSaveButtons, setKitSaveButtons] = useState([
        { label: 'Save and Finish', icon: "icon-save", id: 'save' },
        { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
        { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
    ]);


    const cancelEdition = () => {
        if (kitItem.id < 0) {
            discardKitItem();
        } else {
            setLocalKit(kitItem);
            setEditing(false);
        }
    }

    const discardKitItem = () => {
        infoMsg("Kit part discarded");
        discardItem(kitItem)
    }

    const deleteHandler = () => {
        infoMsg("Removing part form kit");
        deleteKitItem(kitItem).then(response => {
            if ((response.data.responseCode < 300) && (response.data.responseCode > 199)) {
                discardItem(kitItem);
                successMsg("Kit part removed successfully");
            }
        })
    }

    return (<Item ribbon={[{
        when: editing,
        label: LABELS.DRAFT
    }]} item={{}}
    >

        <div className="kit-content">
            <div className={`property ${!editing ? 'has-sub-prop' : ''}`}>
                {!editing ?
                    <>
                        <div className="property">
                            {/* <span>PN</span> */}
                            <b>{localKit.partNumber || "--"}</b>
                        </div>
                        <div className="property">
                            {/* <span>Description</span> */}
                            <b>{localKit.partDescription || "--"}</b>
                        </div>
                    </> : <>
                        <span>PN</span>
                        <Dropdowns activateErrorHint={saveTry && !(typeof (localKit.partId) === 'number')} handleClear={() => handlePartChange(null)} required onOptionSelect={handlePartChange} preSelectValue={kitItem.partId} hideLabel optionLabel="part_number" data={config} parameters={companyParameter} />
                    </>}

            </div>


            <div className="property">
                {/* <span>Category</span> */}
                <b>{localKit.categoryName || "--"}</b>
            </div>
            <div className="property">
                {/* <span>Sub Category</span> */}
                <b>{localKit.subCategoryName || "--"}</b>
            </div>
            <div className="property">
                {/* <span>Quantity</span> */}
                {editing ? <Input value={localKit.quantity} label="" onChange={(e) => setLocalKit(prev => ({ ...prev, quantity: e.target.value }))} isNumeric /> : <b>{localKit.quantity || "--"}</b>}
                <b className="units">{localKit.uomAbreviation || ""}</b>
            </div>
            {/* <div className="property">
                <span>UOM</span>
                <b>{localKit.uomName || "--"}</b>
            </div> */}


            <div className="kitssuffix">
                {!editing && <i className="icon-edit" onClick={() => setEditing(true)}></i>}
                {editing && <MultioptionButton buttons={kitSaveButtons} buttonCallbacks={{
                    'save': () => hanldeSave(true),
                    'save-continue': () => hanldeSave(false),
                    'cancel': () => cancelEdition()
                }}></MultioptionButton>}
                {!editing &&
                    <>
                        {kitItem.id < 0 ?
                            <i className="icon-delete-new" onClick={discardKitItem}></i> :
                            <DialogTrigger dialogContent={{
                                component: DeletePartDialog, props: {
                                    item: { PN: localKit.partNumber, Description: localKit.partDescription, Quantity: localKit.quantity },
                                    message: "Are you sure you want to remove this part from the kit?",
                                    onDelete: deleteHandler
                                }
                            }}>
                                <i className="icon-delete-new"></i>
                            </DialogTrigger>
                        }
                    </>
                }
            </div>
        </div>

    </Item>)
}